import { SideMenuActionTypes } from "./side-menu.types";

const INITIAL_STATE = {
  isCollapsed: true
};

const sideMenuReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SideMenuActionTypes.COLLAPSE_MENU:
      return {
        ...state,
        isCollapsed: true
      };

    case SideMenuActionTypes.SET_COLLAPSE_STATE:
      return {
        ...state,
        isCollapsed: action.payload
      };

    default:
      return state;
  }
};

export default sideMenuReducer;
